"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringReplaceVariables = void 0;
exports.stringReplaceVariables = {
    businessCount: '{{businessCount}}',
    localWeeklyCostB2c: '{{localWeeklyCostB2c}}',
    localMonthlyCostB2c: '{{localMonthlyCostB2c}}',
    localMonthlyCostB2b: '{{localMonthlyCostB2b}}',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RyaW5nLXJlcGxhY2UtdmFyaWFibGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2Ntcy9zdHJpbmctcmVwbGFjZS12YXJpYWJsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxzQkFBc0IsR0FBRztJQUNwQyxhQUFhLEVBQUUsbUJBQW1CO0lBQ2xDLGtCQUFrQixFQUFFLHdCQUF3QjtJQUM1QyxtQkFBbUIsRUFBRSx5QkFBeUI7SUFDOUMsbUJBQW1CLEVBQUUseUJBQXlCO0NBQy9DLENBQUMifQ==